module.exports = __webpack_public_path__ + "static/media/4_l_traleybus_0.31_56.39.25804bc4.png";